import Vue from 'vue';
import Vuex from 'vuex';

import admin from './modules/admin'
import fileList from './modules/fileList' //  文件列表模块
import sideMenu from './modules/sideMenu' //  左侧菜单模块
import common from './modules/common' //  公共模块
import webphoneStrip from './modules/webphoneStrip' //  话务条状态模块
import order from './modules/order' //  新建订单数据模块
import house from './modules/house' //  新建订单数据模块
import {allColumnList} from '@/libs/map.js'
//import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

//const webphoneStripState = createPersistedState({paths: ['webphoneStrip/seatPost', 'webphoneStrip/refreshState']});
export default new Vuex.Store({
    state: {
        fileId: '000000000',
        yongyinData: null,
        officeConfig: '',
        changeTab: 0,
        activeNumber: 0,
        unRead: {},

        prevRoute: null,//全局记录上一个路由
        //这里的值是跟工单表单的值同步的（即可能是用户改过的）
        order: {//新建工单时选中的归口、诉求内容等（用于坐席助手大模型使用）
            caseContent: '',//诉求内容
            caseAccordType: [],//诉求归口
        },
    },
    getters: {
        // 表格显示列
        selectedColumnList: (state) =>
            state.fileList.selectedColumnList === null
                ? allColumnList
                : state.fileList.selectedColumnList.split(','),
        // 文件查看模式
        fileModel: (state) =>
            state.fileList.fileModel === null ? 0 : Number(state.fileList.fileModel),
        // 网格模式 & 时间线模式下 文件图标大小
        gridSize: (state) => state.fileList.gridSize,
        // 剩余存储空间
        remainderStorageValue: (state) =>
            state.sideMenu.totalStorageValue - state.sideMenu.storageValue,

    },
    mutations: {
        changUnRead(state, val) {
            state.unRead = val

        },
        //
        changeFileIds(state, val) {
            state.fileId = val
        },
        changYongyin(state, val) {
            state.yongyinData = val
        },
        changeOfficeConfig(state, val) {
            state.officeConfig = val
        },
        girdTabs(state, val) {
            state.changeTab = val
        },
        changActiveNumber(state, val) {
            state.activeNumber = val
        },
        changPrevRoute(state, value) {
            state.prevRoute = value
        },
        changeOrder(state, val) {
            state.order = val
        },
    },
    actions: {
        changAcUnread({commit}, val) {
            commit('changUnRead', val)
        },
        //
        changeFileId({commit}, fileId) {
            commit('changeFileIds', fileId)
        },
        acChangeYongyin({commit}, value) {
            commit('changYongyin', value)
        },
        acChangeOfficeConfig({commit}, value) {
            commit('changeOfficeConfig', value)
        },
        changTabs({commit}, value) {
            commit('girdTabs', value)
        },
        acChangeNumber({commit}, value) {
            commit('changActiveNumber', value)
        },
        changPrevRouteAction({commit}, value) {
            commit('changPrevRoute', value)
        },
        changeOrderAction({commit}, value) {
            commit('changeOrder', value)
        },
    },
    modules: {
        admin,
        fileList,
        sideMenu,
        common,
        webphoneStrip,
        order,
        house
    },
    //plugins: [webphoneStripState],
})
